module.exports = __webpack_public_path__ + "img/disguise_logo_RGB_Black.dc8041c3.svg";